import React, { useEffect, useRef, useState } from 'react';
import styles from './Dashboard.module.scss';
import Button from 'component/atom/forms/button/Button';
import HomeCard from 'component/molecules/home/home-card/HomeCard';
import RecentActivity from 'component/molecules/home/recent-activity/RecentActivity';
import NewBot from 'component/molecules/companyBots/newbot/NewBot';
import { scriptEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import Loader from 'component/atom/loader/Loader';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';

const Dashboard = () => {
  const [showNewBotModal, setShowNewBotModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const closeTimer = useRef(null);
  const { data, isFetching, refetch } = useFetch(
    ['allBots'],
    scriptEndpoints.getBots()
  );

  const handleEdit = (item) => {
    setSelectedItem(item);
    setShowNewBotModal(true);
  };

  const handleOpenNew = () => {
    setSelectedItem(null);
    setShowNewBotModal(true);
  };

  const handleCloseNewBot = () => {
    setShowNewBotModal(false);
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      setSelectedItem(null);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  return (
    <div className={styles['home-container']}>
      <span className={styles['title']}>Home</span>
      <div className={styles['wrapper']}>
        <div className={styles['header']}>
          <div className={styles['create-agent-container']}>
            <img src='/images/bot-icon-rounded.svg' alt='bot' />
            <div className={styles['create-agent']}>
              <span className={styles['create-agent-title']}>
                Create New Agent
              </span>

              <span className={styles['create-agent-sub']}>
                Deploy intelligent AI assistants for student support,
                admissions, and institutional operations
              </span>
            </div>
          </div>
          <Button label='Start Building' type='plus' onClick={handleOpenNew} />
        </div>
        {isFetching ? (
          <Loader isComponent />
        ) : (
          <div className={styles['body']}>
            <div className={styles['agents-container']}>
              <div className={styles['agents-title-container']}>
                <span className={styles['agents-title']}>Your AI Agents</span>
                <span className={styles['agents-subtitle']}>
                  Past <span className={styles['days']}>7 days</span>{' '}
                  performance overview
                </span>
              </div>
              {data?.data?.length ? (
                <div className={styles['cards-container']}>
                  {data?.data?.map((item) => {
                    return (
                      <HomeCard
                        key={item.id ?? item.botId ?? item.botID}
                        item={item}
                        onEdit={handleEdit}
                        refetch={refetch}
                      />
                    );
                  })}
                </div>
              ) : (
                <NoData type='noAgent' text='No AI Agent Found' />
              )}
            </div>
            <RecentActivity />
          </div>
        )}
      </div>
      <NewBot
        isOpen={showNewBotModal}
        onClose={handleCloseNewBot}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        refetch={refetch}
      />
    </div>
  );
};

export default Dashboard;
